import React from "react";
import styled, { ThemeProvider } from "styled-components";
import PrimaryButtonPR from "../../PrimeReact/PrimaryButtonPR";
import theme from "../../../utils/themes/SFUCentralTheme";

const StyledButton = styled(PrimaryButtonPR)`
  margin-right: ${(props) => props.theme.primaryButton.marginRight};
  padding: ${(props) => props.theme.primaryButton.padding};
  font-family: ${(props) => props.theme.primaryButton.fontFamily};
  font-weight: ${(props) => props.theme.primaryButton.fontWeight};
  font-size: ${(props) => props.theme.primaryButton.fontSize};
  color: ${(props) => props.theme.primaryButton.color};
  text-transform: ${(props) => props.theme.primaryButton.textTransform};
  text-decoration: ${(props) => props.theme.primaryButton.textDecoration};
  background-color: ${(props) => props.theme.primaryButton.backgroundColor};
  border: ${(props) => props.theme.primaryButton.border};
  border-radius: ${(props) => props.theme.primaryButton.borderRadius};

  &:enabled:hover {
    color: ${(props) => props.theme.primaryButton.hover.color};
    background-color: ${(props) =>
      props.theme.primaryButton.hover.backgroundColor};
    border: ${(props) => props.theme.primaryButton.hover.border};
  }

  @media (max-width: 767px) {
    padding: ${(props) => props.theme.primaryButton.mobile.padding};
  }
`;

export default function PrimaryButton({
  children,
  value,
  type,
  onClick,
  className,
  disabled,
}) {
  return (
    <ThemeProvider theme={theme}>
      <StyledButton
        type={type}
        value={value}
        onClick={onClick}
        className={className}
        disabled={disabled}
      >
        {children}
      </StyledButton>
    </ThemeProvider>
  );
}
